import * as $ from 'jquery';
import { LarchSys } from '../utils/larchSys';


export function gotoLinkFeature(larchSys: LarchSys) {

    $('[goto-link]').each(function () {
        const $element = $(this);

        var a = $element.find('a[href]:not([href=""])')[0] as HTMLAnchorElement;
        if (!a) {
            $element.css('cursor', 'auto');
            return;
        }
        else {
            $element.css('cursor', 'pointer');
        }

        $element.one("click", () => {

            const href = a.href;
            const target = a.getAttribute("target");

            if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
                const link = document.createElement('a');
                link.href = href;
                link.target = target;
                document.body.appendChild(link);
                link.click();
            }
            else if (target === "_blank") {
                window.open(href);
            }
            else {
                location.href = href;
            }

        });
    });

}